import React  from "react";
import { useParams } from 'react-router-dom';
import AssignedAssetsForm from "./components/AssignedAssetsForm";

const EditAssignedAssets = () => {
    const { recordId } = useParams();
	return (
        <div>
            <AssignedAssetsForm
                recordId={recordId}
                mode="edit"
            />
        </div>

    );
};

export default EditAssignedAssets;